import { useSuspenseQuery } from '@apollo/client';

import {
  type CompaniesByIndustryQueryVariables,
  CompaniesByIndustryDocument,
} from '../../graphql/queries/companies-by-industry.gql-types';

type CompaniesByIndustriesProps = CompaniesByIndustryQueryVariables & {
  skip?: boolean;
};

export const useCompaniesByIndustry = ({
  limit = 4,
  offset = 0,
  id,
  skip = false,
}: CompaniesByIndustriesProps) =>
  useSuspenseQuery(CompaniesByIndustryDocument, {
    skip,
    variables: {
      limit,
      offset,
      id,
    },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });
